@if (
  afwezigheid().afwezig && (checkIfActiveDate(afwezigheid().van, afwezigheid().tot) || alwaysShow())
) {
  <parkour-profiel-details-card
    [title]="'profiel.unavailable' | translate"
    icon="clock-snooze"
    backgroundColor="bg-n-200"
  >
    <div class="space-y-1">
      @if (afwezigheid().van && afwezigheid().tot) {
        <span class="typo-body variant-body-fat"
          >{{
            'profiel.unavailable-time-from-to'
              | translate
                : {
                    from: afwezigheid().van | date: 'dd.MM.yyyy',
                    to: afwezigheid().tot | date: 'dd.MM.yyyy',
                  }
          }}
        </span>
      } @else {
        <span class="typo-body variant-body-fat"
          >{{
            'profiel.unavailable-time-from'
              | translate
                : {
                    from: afwezigheid().van | date: 'dd.MM.yyyy',
                  }
          }}
        </span>
      }

      @if (afwezigheid().bericht; as bericht) {
        <p class="wysiwyg" [innerHTML]="bericht | linkify"></p>
      }
    </div>
  </parkour-profiel-details-card>
}
